"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _Modal = _interopRequireDefault(require("./Modal"));

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["children", "shouldCloseOnClickOutside", "renderModal", "onClose", "isScrollable", "aria-labelledby"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var WithModalWithoutDocs = function WithModalWithoutDocs(_ref) {
  var children = _ref.children,
      shouldCloseOnClickOutside = _ref.shouldCloseOnClickOutside,
      renderModal = _ref.renderModal,
      onClose = _ref.onClose,
      isScrollable = _ref.isScrollable,
      ariaLabelledBy = _ref['aria-labelledby'],
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var open = function open() {
    setIsOpen(true);
  };

  var close = function close() {
    setIsOpen(false);
  };

  var closeWithCallback = function closeWithCallback() {
    close();
    !!onClose && onClose();
  };

  var ref = (0, _react.useRef)(null);
  return (0, _core.jsx)(_react.default.Fragment, null, children({
    open: open,
    close: close,
    isOpen: isOpen
  }), (0, _core.jsx)(_Modal.default, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    ref: ref,
    isOpen: isOpen,
    close: closeWithCallback,
    shouldCloseOnClickOutside: shouldCloseOnClickOutside,
    "aria-labelledby": ariaLabelledBy || _constants.MODAL_TITLE_ID,
    isScrollable: isScrollable
  }), renderModal({
    close: closeWithCallback,
    ref: ref
  })));
};

var WithModalWithDocs = (0, _stencilReactDesc.describe)(WithModalWithoutDocs).description('FAC component for displaying a modal.');
WithModalWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function used to trigger modals.').format("({\n  open: () => void,\n  close: () => void,\n  isOpen: boolean\n}) => React.ReactNode\n  "),
  renderModal: _stencilReactDesc.PropTypes.func.isRequired.description('Render function to render the content of the modal.').format("({\n  close: () => void,\n  ref: node\n}) => React.ReactNode"),
  shouldCloseOnClickOutside: _stencilReactDesc.PropTypes.bool.description('Whether the modal can be closed by clicking outside of it.'),
  onClose: _stencilReactDesc.PropTypes.func.description('Callback called when the modal is closed.').format('() => void'),
  isScrollable: _stencilReactDesc.PropTypes.bool.description('Toggles whether the modal is scrollable.'),
  'aria-labelledby': _stencilReactDesc.PropTypes.string.description('The ID of the element that labels the modal. Use this with titleId prop on ModalHeader for accessibility.')
};
var WithModal = (0, _utils.withTestAttributes)({})(WithModalWithDocs);
WithModal.displayName = 'WithModal';
var _default = WithModal;
exports.default = _default;